module.exports = __webpack_public_path__ + "static/media/notification.b6e6873.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/globals/header/sounds/notification.mp3
// module id = LJ3m
// module chunks = 1